import setVisit from './setVisit';
import setVisits from './setVisits';
import setPastVisits from './setPastVisits';
import setVisitsFilters from './setVisitsFilters';
import setClientDocuments from './setClientDocuments';
import setClientDocumentsFilter from './setClientDocumentsFilter';
import resetCurrentVisit from './resetCurrentVisit';

export default {
  setVisit,
  resetCurrentVisit,
  setVisits,
  setPastVisits,
  setVisitsFilters,
  setClientDocuments,
  setClientDocumentsFilter,
};
